import React, { Component, useState } from "react";
import { Container, Card, CardBody, Row, Col, Nav, NavItem, NavLink, TabContent, TabPane, Table, Media, Input, Button, InputGroup, InputGroupAddon, UncontrolledTooltip, Label } from "reactstrap";
import { Link } from "react-router-dom";
import classnames from "classnames";
import ReactModal from "react-modal";
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import MiniWidgets from "../Dashboard/MiniWidgets";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
//Import Product Images
import img1 from "../../assets/images/product/img-1.png";
import img5 from "../../assets/images/product/img-5.png";
import img3 from "../../assets/images/product/img-3.png";
import img4 from "../../assets/images/product/img-4.png";
import lev from "../../assets/images/product/lev_charger.jpg";
import ac06 from "../../assets/images/product/cfac06.jpg";
import ac06m from "../../assets/images/product/cfac06m.png";

import user1 from "../../assets/images/users/avatar-2.jpg";
import store from "../../store";
import io from "socket.io-client";
import { connect } from "react-redux";
import { chargerSelected } from "../../store/chargers/actions";
import { MDBDataTable } from "mdbreact";
import { blockOrUnblockUser, getTransactionByUserId, getUser, getUserByRFID } from "../../api/userAPI";
import { getTransaction } from "../../api/transactionAPI";
import { getStatus } from "../../api/statusAPI";
import { ChargerDiv } from "../Utility/styleComponents";
import AddUser from "./AddUser";
import LKTimerImg from "../../assets/images/LK_Icons/LK__Timer-clock.svg";
import LKRevenueImg from "../../assets/images/LK_Icons/LK__View Trend.svg";
import LKMailImg from "../../assets/images/LK_Icons/LK__mail.svg";
import LKPhoneImg from "../../assets/images/LK_Icons/LK__Phone.svg";
import LKSavingImg from "../../assets/images/LK_Icons/LK__Savings.svg";
import LKTransactionImg from "../../assets/images/LK_Icons/LK__Transaction History 1.svg";
import LKDownloadImg from "../../assets/images/LK_Icons/LK_Download.svg";
import LKEditImg from "../../assets/images/LK_Icons/LK_Modify-Edit.svg";
import LKDeleteImg from "../../assets/images/LK_Icons/LK_Delete.svg";
import LKReportImg from "../../assets/images/LK_Icons/LK_Report.svg";
import { getCharger, getChargerById } from "../../api/chargerAPI";
import { downloadInvoiceInPDF } from "../../api/downloadInvoice";
import { warningToast } from "../../store/dbFilter/actions";
import { computeRevenue } from "../Utility/utilsFunctions";
let socket;
let userId_1 = "6076A1ACCD98";
let userId_2 = "F8474CEF49C0";
let userId_3 = "20898795AB34";

//const rating = "7.2";
let pollInterval;
const expandRow = {
  renderer: (row) => (
    <>
      Action :
      <Link to="#" className="mr-3 text-primary">
        <i className="mdi mdi-pencil font-size-18"></i>
      </Link>
      <Link to="#" className="text-danger">
        <i className="mdi mdi-trash-can font-size-18"></i>
      </Link>
    </>
  ),

  showExpandColumn: true,
  expandByColumnOnly: true,
};

class UserDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      breadcrumbItems: [
        { title: "Charger Management System", link: "#" },
        { title: "User Details", link: "#" },
      ],
      activeTab: "1",
      activeTab2: "1",
      chargerStatus: "Offline",
      start_btn_clr: "#5664D2",
      stop_btn_clr: "#EFF2F7",
      start_btn_txt_clr: "#ffffff",
      stop_btn_txt_clr: "#000000",
      chargerId: props.selectedChargerId,
      userId: props.selectedUserId?.phoneNumber,
      userData: {},
      isBlock: props.selectedUserId?.status === "Blocked" ? true : false,
      isEditRFID: false,
      // userId: props.location.phone,
      transLog: [],
      faultLog: [],
      consumption: "Syncing...",
      ActiveTransactionId: 0,
      ocppId: "",
      syncIntervalId: "",
      imgSrc: user1,
      rating: "7.2",
      lasthb: "",
      perUnitRate: 0,
      currency: "₹",
      protocol: "Ocpp1.6",
      connectors: "",
      firmwareVersion: "",
      rfidHover: false,
      noOfTrans: 0,
      totalRevenue: 0,
    };
    this.toggleTab = this.toggleTab.bind(this);
    this.toggleTab2 = this.toggleTab2.bind(this);
    this.imageShow = this.imageShow.bind(this);
  }

  toggleTab(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  }

  toggleTab2(tab) {
    if (this.state.activeTab2 !== tab) {
      this.setState({
        activeTab2: tab,
      });
    }
  }

  toggleChargeButtons = (chargerStatus) => {
    if (chargerStatus == null) return;

    if (chargerStatus === "Charging") {
      this.setState({
        start_btn_clr: "#EFF2F7",
        stop_btn_clr: "#FF3D60",
        start_btn_txt_clr: "#000000",
        stop_btn_txt_clr: "#ffffff",
      });
    } else {
      this.setState({
        start_btn_clr: "#5664D2",
        stop_btn_clr: "#EFF2F7",
        start_btn_txt_clr: "#ffffff",
        stop_btn_txt_clr: "#000000",
      });
    }
  };

  imageShow(img, id) {
    var expandImg = document.getElementById("expandedImg" + id);
    expandImg.src = ac06;
  }

  updateChargerImage = () => {
    /*   let src = ac06;
  
          if (this.state.chargerId === null)
              src = ac06;
  
          if (this.state.chargerId === chargerId_1)
              src = ac06m;
  
          if (this.state.chargerId === chargerId_2)
              src = lev;
  
          if (this.state.chargerId === chargerId_3)
              src = ac06;
  
          this.setState({ imgSrc: src }); */
  };

  renderStatus = () => {
    if (this.state.chargerStatus === "Charging") {
      //return "mr-2 text-success";

      return "p-2 mr-2 text-white bg-success rounded";
    }
    if (this.state.chargerStatus === "Available") return "mr-2 text-success";
    //return "p-1 mr-2 text-white bg-primary rounded";

    if (this.state.chargerStatus === "Preparing") return "mr-2 text-warning";
    //return "p-1 mr-2 text-white bg-warning rounded";
    if (this.state.chargerStatus === "Faulted")
      // return "mr-2 text-danger";
      return "p-2 mr-2 text-white bg-danger rounded";
    if (this.state.chargerStatus === "Finishing") return "mr-2 text-warning";

    if (this.state.chargerStatus === "Offline") return "mr-2 text-danger";
    //return "p-1 mr-2 text-white bg-warning rounded";

    //return "mr-2 text-info";
    return "p-1 mr-2 text-white bg-info rounded";
  };

  /*  socketSend = (topic, payload) => {
         if (topic == null)
             return;
 
         if (payload == null)
             return;
 
         if ((topic.toString().length <= 0) || (payload.toString().length <= 0))
             return;
 
         if (socket == null)
             return;
 
         if (!socket.active)
             return;
 
         socket.emit("publish", JSON.stringify({ topic, payload }));
     } */

  /*  msgSubscribe = (topic) => {
         if (socket == null)
             return;
 
         if (!socket.active)
             return;
 
         socket.emit("subscribe", { topic: this.getResponseTopic(this.state.chargerId) });
     }
 
     getResponseTopic = (chargerId) => {
         if (chargerId == null)
             return;
 
         return "/cms/" + chargerId + "/response";
     }
 
     getRequestTopic = (chargerId) => {
         if (chargerId == null)
             return;
 
         return "/cms/" + chargerId;
     } */

  async componentDidMount() {
    ReactModal.setAppElement("#root");
    await this.handleGetUser();
    try {
      console.log("UserDetail Props", this.props);
      const charger_status = await this.updateUserTransactions(this.state.userId);
    } catch (e) {
      console.log("Charger Details Update Error", e.toString());
    }

    const intervalId = setInterval(async () => {
      try {
        //console.log("Charger Update Routine");
        // await this.updateUserDetails(this.state.userId);
        await this.updateUserTransactions(this.state.userId);
      } catch (e) {
        console.log("Charger Details Update Error", e.toString());
      }
    }, 5000);

    this.setState({ syncIntervalId: intervalId });
  }
  handleGetUser = () => {
    try {
      const { rfids } = this.props?.selectedUserId;
      const payType = rfids?.length === 0 ? "Prepaid" : "Postpaid";
      const rfidStr = rfids?.map((item) => item).join(", ");
      this.setState({ userData: { ...this.props?.selectedUserId, payType, rfidStr } });
    } catch (err) {
      console.log("Error getting the User", err.msg);
    }
  };

  handleUserStatus = async (status) => {
    const { hostId, phoneNumber } = this.state.userData;
    // const findStatus = status ? "Blocked" : "Accepted";
    try {
      const response = await blockOrUnblockUser({ hostId, phoneNumber, status });
      console.log("response : ", response);
      const { message, data } = response;
      console.log(`${message}`, data?.user?.status);
      if (message === "success") {
        this.setState({ isBlock: data?.user?.status === "Blocked" ? true : false });
      }
    } catch (err) {
      console.log("Error getting the User", err.msg);
    }
  };
  async componentWillUnmount() {
    this.setState({ transLog: [], consumption: "0" });
    clearInterval(this.state.syncIntervalId);
  }

  computeTime = (isodate) => {
    if (isodate == null) return "";

    const date = new Date(isodate);

    let hour = date.getHours().toString();
    let mins = date.getMinutes().toString();
    let secs = date.getSeconds().toString();

    if (hour.length < 2) hour = "0" + hour;

    if (mins.length < 2) mins = "0" + mins;

    if (secs.length < 2) secs = "0" + secs;

    return hour + ":" + mins + ":" + secs;
  };

  computeDate = (isodate) => {
    if (isodate == null) return "";

    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    const date = new Date(isodate);
    let day = date.getDate();
    let month = date.getMonth();
    let year = date.getFullYear().toString();

    if (day < 10) day = "0" + day.toString();

    if (month < 10) month = "0" + month.toString();

    return day + " " + months.at(month) + ", " + year;
  };

  computeConsumption = (starMeterVal, stopMeterVal) => {
    if (isNaN(starMeterVal)) return "";

    if (isNaN(stopMeterVal)) return <div className="badge badge-soft-warning font-size-12">On-going</div>;

    return ((parseInt(stopMeterVal, 10) - parseInt(starMeterVal, 10)) / 1000).toString();
  };

  computeTotal = (starMeterVal, stopMeterVal) => {
    if (isNaN(stopMeterVal)) return <div className="badge badge-soft-warning font-size-12">On-going</div>;

    return "\u20B9" + (((parseInt(stopMeterVal, 10) - parseInt(starMeterVal, 10)) * 10) / 1000).toString();
  };
  // computeTotalRevenue = (starMeterVal, stopMeterVal) => {
  //   if (isNaN(stopMeterVal)) return 0;

  //   return ((parseInt(stopMeterVal, 10) - parseInt(starMeterVal, 10)) * 10) / 1000;
  // };
  computePaymentStatus = (starMeterVal, stopMeterVal) => {
    if (isNaN(stopMeterVal)) return <div className="badge badge-soft-warning font-size-12">Paid</div>;

    return <div className="badge badge-soft-success font-size-12">Paid</div>;
  };

  updateUserDetails = async (userId) => {
    if (userId == null) return;
    try {
      const response = await getUser(userId);
      console.log("response : ", response);
      const { message, data } = response;
      console.log(`${message}`, data);
      if (data.length <= 0) return;
      //console.log("Fetch data Reponse", data.at(0));
      // return data.at(0).status;
    } catch (err) {
      if (err.isErr) {
        console.log("Error getting the User", err.msg);
        console.log("Problem: ", err.problem);
      } else {
        console.log("Unexpected Error: ", err);
      }
      return err;
    }
  };
  // to update the selected charger data
  selectCharger = (chargerId) => {
    if (chargerId === null) return;
    store.dispatch(chargerSelected(chargerId));
  };

  updateUserTransactions = async (userId) => {
    if (userId == null) return;
    try {
      const response = await getTransactionByUserId(userId);
      const { message, data } = response;
     

      if (data?.length === 0) {
        console.log("There are no Recent Transaction ");
        return;
      }
      let revenueTotal = 0;
      let trans_data = [];
      data.forEach((item) => {
        // Update revenue total
        revenueTotal += computeRevenue(parseInt(item.meterStart, 10), parseInt(item.meterStop, 10),item.pricePerUnit);
        const onClickData = () => {
          if (isNaN(item.meterStop)) {
            this.props.warningToast({
              title: "Warning",
              message: "Cannot download Invoice for On-going transaction",
            });
            return;
          }
          const data = {
            transactionId: item.transactionId,
            chargerId: item.chargerId,
            startTime: `${this.computeDate(item.startTime)}, ${this.computeTime(item.startTime)}`,
            endTime: `${this.computeDate(item.stopTime)}, ${this.computeTime(item.stopTime)}`,
            consumption: this.computeConsumption(parseInt(item.meterStart, 10), parseInt(item.meterStop, 10)),
            price: item.pricePerUnit,
          };
          return { data };
        };
        // Push transaction details into trans_data
        trans_data.push({
          id: item.chargerId,
          displayId: (
            <ChargerDiv
              key={item.chargerId}
              onClick={() => {
                this.selectCharger(item.chargerId);
                this.props.history.push("/cms-charger-detail");
              }}
            >
              {item.chargerId}
            </ChargerDiv>
          ),
          date: this.computeDate(item.startTime) + ", " + this.computeTime(item.startTime),
          userid: item.userId,
          conn: item.connectorId,
          kWh: this.computeConsumption(parseInt(item.meterStart, 10), parseInt(item.meterStop, 10)),
          total: this.computeTotal(parseInt(item.meterStart, 10), parseInt(item.meterStop, 10)),
          type: item.type,
          status: this.computePaymentStatus(parseInt(item.meterStart, 10), parseInt(item.meterStop, 10)),
          invoice: (
            <img
              src={LKDownloadImg}
              alt="downloadImg"
              style={{ width: "20px", height: "20px",cursor:"pointer" }}
              onClick={async () => {
                const data = onClickData();
                await this.handleDownloadInvoice(data);
              }}
            />
          ),
        });
      });

      if (JSON.stringify(trans_data) === JSON.stringify(this.state.transLog)) return;

      this.setState({ transLog: trans_data, noOfTrans: data?.length, totalRevenue: revenueTotal.toFixed(2) });
    } catch (err) {
      if (err.isErr) {
        console.log("Error fetching transaction by userId ", err.msg);
        console.log("Problem: ", err.problem);
      } else {
        console.log("Unexpected Error: ", err);
      }
      return err;
    }
  };

  getConnectorDetails = (connectors) => {
    if (connectors == null) return "";

    if (connectors.length <= 0) return "";

    let connDetails = "";

    if (connectors.length == 1) connDetails = "Single-gun ";
    else if (connectors.length == 2) connDetails = "Dual-gun ";
    else connDetails = "Muli-gun ";

    connectors.forEach((conn) => {
      connDetails += conn.connectorType + ";";
    });

    return connDetails;
  };

  getCurrencySymbol = (currency) => {
    if (currency == null) return "";

    switch (currency.toLowerCase()) {
      case "rupee":
        return "₹";

      case "usd":
        return "$";

      case "pound":
        return "£";

      default:
        return currency;
    }
  };

  updateChargerTransLog = async (chargerId) => {
    //console.log("Update Charger Id", chargerId);

    if (chargerId == null) return;
    try {
      const response = await getTransaction(chargerId);
      const { message, data } = response;
      console.log(`${message}`, data);
      let i = 0,
        trans_data = [];
      data.forEach((item) => {
        trans_data.push({
          connId: item.connectorId,
          chargerId: (
            <Link to="cms-charger-detail" className="text-dark font-weight-bold">
              {item.chargerId}
            </Link>
          ),
          date: this.computeDate(item.startTime) + ", " + this.computeTime(item.startTime),
          user: item.userId,
          transactionId: item.transactionId,
          total: this.computeTotal(parseInt(item.meterStart, 10), parseInt(item.meterStop, 10)),
          units: this.computeConsumption(parseInt(item.meterStart, 10), parseInt(item.meterStop, 10)),
          status: this.computePaymentStatus(parseInt(item.meterStart, 10), parseInt(item.meterStop, 10)),
        });
      });

      if (JSON.stringify(trans_data) === JSON.stringify(this.state.transLog)) return;

      this.setState({ transLog: trans_data });
    } catch (err) {
      if (err.isErr) {
        console.log("Error getting the Transaction ", err.msg);
        console.log("Problem: ", err.problem);
      } else {
        console.log("Unexpected Error: ", err);
      }
      return err;
    }

    //console.log("Data Fetched");
  };

  updateChargerFaultLog = async (chargerId) => {
    //console.log("Update Charger Id", chargerId);

    if (chargerId == null) return;
    try {
      const response = await getStatus(chargerId, "Faulted");
      const { message, data } = response;
      console.log(`${message}`, data);

      data.sort((a, b) => -a.timeStamp.localeCompare(b.timeStamp));

      let fault_data = [];
      data.forEach((item) => {
        fault_data.push({
          connId: item.connectorId,
          chargerId: item.chargerId,
          timeStamp: this.computeDate(item.timeStamp) + " " + this.computeTime(item.timeStamp),
          details: item.details,
        });
      });

      if (JSON.stringify(fault_data) === JSON.stringify(this.state.faultLog)) return;

      //console.log("Fault Data Log", data);

      this.setState({ faultLog: fault_data });
    } catch (err) {
      if (err.isErr) {
        console.log("Error getting the Transaction ", err.msg);
        console.log("Problem: ", err.problem);
      } else {
        console.log("Unexpected Error: ", err);
      }
      return err;
    }
  };

  // to download the invoice
  handleDownloadInvoice = async (transactionData) => {
    try {
      this._isMounted && this.setState({ isDownloadLoading: true });

      const invoiceData = {
        ...transactionData?.data,
        phno: this.state.userData?.phoneNumber,
        email: this.state.userData?.email,
        serviceProvider: this.props.user.name || "",
        GST: this.props.user.gst || "",
        address: this.props.user.address || "",
        description: "Charging Session",
      };
      
      await downloadInvoiceInPDF(invoiceData);
    } catch (err) {
      console.log("Problem: ", err.problem, err.msg);
    } finally {
      this._isMounted && this.setState({ isDownloadLoading: false });
    }
  };

  render() {
    const data = {
      columns: [
        // {
        //   label: (
        //     <div className="custom-control custom-checkbox">
        //       {" "}
        //       <Input type="checkbox" className="custom-control-input" id="ordercheck" />
        //       <Label className="custom-control-label" htmlFor="ordercheck">
        //         &nbsp;
        //       </Label>
        //     </div>
        //   ),
        //   field: "checkbox",
        //   sort: "asc",
        //   width: 28,
        // },
        {
          label: "Charger ID",
          field: "displayId",
          sort: "asc",
          width: 78,
        },
        {
          label: "Conn ID",
          field: "conn",
          sort: "asc",
          width: 28,
        },
        {
          label: "Date",
          field: "date",
          sort: "asc",
          width: 93,
        },
        {
          label: "User Id",
          field: "userid",
          sort: "asc",
          width: 109,
        },
        {
          label: "Type",
          field: "type",
          sort: "asc",
          width: 28,
        },
        {
          label: "Units",
          field: "kWh",
          sort: "asc",
          width: 28,
        },
        {
          label: "Total",
          field: "total",
          sort: "asc",
          width: 48,
        },
        {
          label: "Payment Status",
          field: "status",
          sort: "asc",
          width: 135,
        },
        {
          label: "Invoice",
          field: "invoice",
          sort: "asc",
          width: 110,
        },
        // {
        //   label: "Action",
        //   field: "action",
        //   sort: "asc",
        //   width: 120,
        // },
      ],
      rows: this.state.transLog,
    };

    const options = {
      // pageStartIndex: 0,
      hideSizePerPage: false,
      hidePageListOnlyOnePage: false,
      sizePerPageList: [
        {
          text: "5th",
          value: 5,
        },
        {
          text: "10th",
          value: 10,
        },
        {
          text: "All",
          value: this.state.transLog.length,
        },
      ],
    };

    const optionsFault = {
      // pageStartIndex: 0,
      hideSizePerPage: false,
      hidePageListOnlyOnePage: false,
      sizePerPageList: [
        {
          text: "5th",
          value: 5,
        },
        {
          text: "10th",
          value: 10,
        },
        {
          text: "All",
          value: this.state.faultLog.length,
        },
      ],
    };

    const selectRow = {
      mode: "checkbox",
      clickToSelect: true,
    };

    const start_click = () => {
      if (this.state.chargerStatus === "Offline") {
        alert("Charger is Offline");
        return;
      }

      if (this.state.chargerStatus !== "Charging") {
        /* console.log("Socket Send Topic", this.getRequestTopic(this.state.chargerId));
 
                console.log("Socket Send Payload", JSON.stringify({
                    type: "remoteStart",
                    idTag: "9902062209",
                    connectorId: 1
                })); */

        this.socketSend(this.getRequestTopic(this.state.chargerId), {
          type: "remoteStart",
          idTag: "9902062209",
          connectorId: 1,
        });
      }
    };

    const stop_click = () => {
      //console.log("Stop Charge TransactionId", this.state.ActiveTransactionId);
      if (this.state.ActiveTransactionId === 0) {
        alert("Not Authorized to stop this transaction");
        return;
      }

      if (this.state.chargerStatus === "Offline") {
        alert("Charge is Offline");
        return;
      }

      this.socketSend(this.getRequestTopic(this.state.chargerId), {
        type: "remoteStop",
        transactionId: this.state.ActiveTransactionId,
      });
    };

    //let meter_value = 0.0;

    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            <Breadcrumbs title="User Details" breadcrumbItems={this.state.breadcrumbItems} />
            {this.state.isEditRFID && (
              <AddUser
                userData={this.state.userData}
                isModalOpen={this.state.isEditRFID}
                closeModal={(isUpdated) => {
                  this.setState({ isEditRFID: false });
                  isUpdated && this.handleGetUser();
                }}
              />
            )}
            <Row>
              <Col lg={12}>
                <Card>
                  <CardBody>
                    <Row>
                      <Col xl={4}>
                        <div className="product-detail">
                          <Row>
                            <Col md={8} xs={9} className="d-flex justify-content-center mt-4 mt-xl-3">
                              <TabContent activeTab={this.state.activeTab} id="v-pills-tabContent">
                                <TabPane tabId="1">
                                  <div className="product-img">
                                    <img src={this.state.imgSrc} id="expandedImg1" style={{ height: 200 }} alt="" className="img-fluid mx-auto d-block rounded" />
                                  </div>
                                </TabPane>
                                <TabPane tabId="2">
                                  <div className="product-img">
                                    <img src={this.state.imgSrc} id="expandedImg2" alt="" className="img-fluid mx-auto d-block" />
                                  </div>
                                </TabPane>
                                <TabPane tabId="3">
                                  <div className="product-img">
                                    <img src={this.state.imgSrc} id="expandedImg3" alt="" className="img-fluid mx-auto d-block" />
                                  </div>
                                </TabPane>
                                <TabPane tabId="4">
                                  <div className="product-img">
                                    <img src={this.state.imgSrc} id="expandedImg4" alt="" className="img-fluid mx-auto d-block" />
                                  </div>
                                </TabPane>
                              </TabContent>
                            </Col>
                          </Row>
                          {this.state.userData?.rfidStr && (
                            <Row>
                              <Col md={8} xs={9} className="d-flex justify-content-center mt-2">
                                <div>
                                  {this.state.isBlock ? (
                                    <button
                                      className="btn btn-light rounded-pill py-1 px-5 mt-1 fw-bold"
                                      onClick={() => {
                                        this.handleUserStatus("Accepted");
                                        // this.setState({ isBlock: false });
                                      }}
                                    >
                                      <b> Unblock </b>
                                    </button>
                                  ) : (
                                    <button
                                      className="btn btn-danger rounded-pill py-1 px-5 mt-1 fw-bold "
                                      onClick={() => {
                                        // this.setState({ isBlock: true });
                                        this.handleUserStatus("Blocked");
                                      }}
                                    >
                                      Block
                                    </button>
                                  )}
                                </div>
                              </Col>
                            </Row>
                          )}
                        </div>
                      </Col>
                      <Col xl={7}>
                        <div className="mt-4 mt-xl-3">
                          <Link to="#" className="text-primary">
                            Email Id: {this.state.userData?.email}
                          </Link>
                          <div className="d-flex justify-content-start align-items-center mt-1 mb-3">
                            {this.state.isBlock ? (
                              <span className="px-2 py-2 bg-danger d-inline-block rounded-pill"></span>
                            ) : (
                              <span className="px-2 py-2 bg-success d-inline-block rounded-pill"></span>
                            )}

                            <h5 className="pl-2 m-0">{this.state.userData?.name}</h5>
                          </div>

                          <hr className="my-4" />
                          <h5 className="font-size-14">About User</h5>
                          <Row>
                            <Col>
                              <div className="d-flex flex-column mb-1">
                                {/* Contact */}
                                <div className="d-flex align-items-start mb-2">
                                  <span className="d-flex align-items-center" style={{ minWidth: "140px" }}>
                                    <img src={LKPhoneImg} alt="LKPhoneImg" style={styles.imgStyle} />
                                    <b>Contact</b>
                                  </span>
                                  <b style={styles.colonStyle}>:</b>
                                  <span style={styles.valueStyle}>{this.state.userData?.phoneNumber}</span>
                                </div>

                                {/* Email */}
                                <div className="d-flex align-items-start mb-2">
                                  <span className="d-flex " style={{ minWidth: "140px" }}>
                                    <img src={LKMailImg} alt="LKMailImg" style={styles.imgStyle} />
                                    <b>Email</b>
                                  </span>
                                  <b style={styles.colonStyle}>:</b>
                                  <span style={styles.valueStyle}> {this.state.userData?.email}</span>
                                </div>
                                {/* Payment type */}
                                <div className="d-flex align-items-start mb-2">
                                  <span className="d-flex " style={{ minWidth: "140px" }}>
                                    <img src={LKTimerImg} alt="LKTimerImg" style={styles.imgStyle} />
                                    <b>Payment Type</b>
                                  </span>
                                  <b style={styles.colonStyle}>:</b>
                                  <span style={styles.valueStyle}> {this.state.userData?.payType}</span>
                                </div>
                              </div>
                            </Col>
                            <Col>
                              <div className="d-flex flex-column mb-1">
                                {/* No. of Transaction */}
                                <div className="d-flex align-items-start mb-2">
                                  <span className="d-flex align-items-center" style={{ minWidth: "140px" }}>
                                    <img src={LKTransactionImg} alt="LKTransactionImg" style={styles.imgStyle} />
                                    <b>No. of Transaction</b>
                                  </span>
                                  <b style={styles.colonStyle}>:</b>
                                  <span style={styles.valueStyle}>{this.state.noOfTrans}</span>
                                </div>
                                {/* Total Revenue */}
                                <div className="d-flex align-items-start mb-2">
                                  <span className="d-flex " style={{ minWidth: "140px" }}>
                                    <img src={LKRevenueImg} alt="LKTimerImg" style={styles.imgStyle} />
                                    <b>Total Revenue:</b>
                                  </span>
                                  <b style={styles.colonStyle}>:</b>
                                  <span style={styles.valueStyle}> {this.state.totalRevenue}</span>
                                </div>
                                {/* Balance */}
                                <div className="d-flex align-items-start mb-2">
                                  <span className="d-flex " style={{ minWidth: "140px" }}>
                                    <img src={LKSavingImg} alt="LKSavingImg" style={styles.imgStyle} />
                                    <b>Balance</b>
                                  </span>
                                  <b style={styles.colonStyle}>:</b>
                                  <span style={styles.valueStyle}> {this.state.userData?.payType === "Prepaid" ? "NA" : this.state.userData?.balance}</span>
                                </div>
                              </div>
                            </Col>
                            <div></div>
                          </Row>
                          {/* <Row>
                            <Col>
                              <div className="d-flex justify-content-start align-items-center">
                                <i className="ri-bank-card-line text-primary mr-1 align-middle font-size-16"></i>
                                <span>
                                  <b>Rfid Cards: </b>
                                  {this.state.userData?.rfidStr || "NA"}
                                </span>
                              </div>
                            </Col>
                          </Row> */}
                          {this.state.userData?.rfidStr && (
                            <Row>
                              <Col className="d-flex align-items-center">
                                <img src={LKReportImg} alt="LKReportImg" style={styles.imgStyle} />
                                <span
                                  className="text-primary text-underline mt-1 "
                                  onClick={() => this.setState({ isEditRFID: true })}
                                  style={{ cursor: "pointer", textDecoration: this.state.rfidHover ? "underline" : "none" }}
                                  onMouseOver={() => this.setState({ rfidHover: true })}
                                  onMouseLeave={() => this.setState({ rfidHover: false })}
                                >
                                  View RFID
                                </span>
                              </Col>
                            </Row>
                          )}
                        </div>
                      </Col>
                    </Row>

                    <div className="mt-4">
                      <MDBDataTable responsive data={data} className="mt-4" style={{ textAlign: "center" }} />
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}
const styles = {
  colonStyle: { width: "10px", textAlign: "center" },
  valueStyle: { marginLeft: "8px", flex: 1 },
  imgStyle: { width: "16px", height: "16px", marginRight: "6px" },
};

const mapStateToProps = (state) => ({
  selectedUserId: state.UserManagement.selectedUserId,
});

const mapDispatchToProps = (dispatch) => ({
  chargerSelected: (userId) => dispatch(chargerSelected(userId)),
  warningToast: (payload) => dispatch(warningToast(payload)),
});
export default connect(mapStateToProps, mapDispatchToProps)(UserDetail);
